export const defaultStyles = {
  color: "var(--theme-website-color-text-primary)",
  fontWeight: "500",
  fontSize: "16px",
  lineHeight: "1.5",
  fontStyle: "normal",
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
  padding: {
    paddingTop: "0",
    paddingBottom: "0",
    paddingLeft: "0",
    paddingRight: "0",
  },
} as const;
